import { http } from '@/lib/http';

/** Códigos do `detail` das recusas — espelham `src/core/terms.py`. */
export const TERMS_NOT_ACCEPTED = 'terms_not_accepted';
export const TERMS_VERSION_OUTDATED = 'terms_version_outdated';

export interface TermsAcceptResponse {
  version: string;
  accepted_at: string;
}

export const welcomeApi = {
  acceptTerms: (version: string) =>
    http.post<TermsAcceptResponse>('/storefront/terms/accept', { version }),
};
